import { render } from "./menu.vue?vue&type=template&id=5f5a45be&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=5f5a45be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f5a45be"

export default script